import React, { memo } from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { company } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-brand-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img src={company.logoUrl} alt="Magic Deumidificazioni" className="h-12 w-auto object-contain bg-white rounded-md p-2" loading="lazy" decoding="async" width="180" height="48" />
            <p className="text-white/70 mt-4 text-sm leading-relaxed max-w-md">
              Intervento urgente 24h per allagamento e danni d&rsquo;acqua in Ticino. Deumidificazione, prosciugamento, ricerca perdite e risanamento edile.
            </p>
            <div className="flex gap-3 mt-5">
              <a href={company.facebookLink} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-red transition-colors flex items-center justify-center">
                <Facebook className="w-4 h-4" />
              </a>
              <a href={company.instagramLink} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-red transition-colors flex items-center justify-center">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-bold uppercase tracking-wide text-sm mb-4">Contatti</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-red shrink-0" />
                <span>{company.address}<br />{company.city}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-brand-red shrink-0" />
                <a href={`tel:${company.phoneRaw}`} className="hover:text-brand-red">{company.phone}</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-brand-red shrink-0" />
                <a href={`mailto:${company.email}`} className="hover:text-brand-red break-all">{company.email}</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold uppercase tracking-wide text-sm mb-4">Link Rapidi</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li><a href="/#home" className="hover:text-brand-red">Home</a></li>
              <li><a href="/#azienda" className="hover:text-brand-red">Azienda</a></li>
              <li><a href="/#servizi" className="hover:text-brand-red">Servizi</a></li>
              <li><a href="/#footer-contatti" className="hover:text-brand-red">Contatti</a></li>
              <li><a href="#" className="hover:text-brand-red">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-brand-red">Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div id="footer-contatti" className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 items-center text-xs text-white/60 scroll-mt-24">
          <p>&copy; {new Date().getFullYear()} {company.name} | {company.vat}</p>
          <p>Tutti i diritti riservati.</p>
        </div>
      </div>

      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-brand-navy border-t border-white/10 z-40 flex">
        <a href={`tel:${company.phoneRaw}`} className="flex-1 flex items-center justify-center gap-2 bg-brand-red text-white py-3 font-bold text-sm uppercase">
          <Phone className="w-4 h-4" /> Emergenza 24/7
        </a>
      </div>
    </footer>
  );
};

export default memo(Footer);
